/**
 * Convert audiences data to CSV format
 * @param {Array} audiences - Array of audience objects with audience_name and subreddit_name
 * @returns {string} CSV string
 */
export const convertAudiencesToCSV = (audiences) => {
  if (!audiences || audiences.length === 0) {
    return null;
  }
  
  const rows = [];
  
  // Write header row
  rows.push(['audience_name', 'subreddit_name']);
  
  // Add data rows
  audiences.forEach(item => {
    rows.push([
      escapeCSVValue(item.audience_name || ''),
      escapeCSVValue(item.subreddit_name || '')
    ]);
  });
  
  return convertRowsToCSV(rows);
};

/**
 * Convert tracked keywords data to CSV format
 * @param {Array} trackedKeywords - Array of tracked keyword objects with name, search_query, subreddits
 * @returns {string} CSV string
 */
export const convertTrackedKeywordsToCSV = (trackedKeywords) => {
  if (!trackedKeywords || trackedKeywords.length === 0) {
    return null;
  }
  
  const rows = [];
  
  // Write header row
  rows.push(['name', 'search_query', 'subreddits']);
  
  // Add data rows
  trackedKeywords.forEach(item => {
    rows.push([
      escapeCSVValue(item.name || ''),
      escapeCSVValue(item.search_query || ''),
      escapeCSVValue(item.subreddits || '')
    ]);
  });
  
  return convertRowsToCSV(rows);
};

/**
 * Convert bookmarks data to CSV format
 * @param {Array} bookmarks - Array of bookmark objects with bookmark_name and url
 * @returns {string} CSV string
 */
export const convertBookmarksToCSV = (bookmarks) => {
  if (!bookmarks || bookmarks.length === 0) {
    return null;
  }
  
  const rows = [];
  
  // Write header row
  rows.push(['bookmark_name', 'url']);
  
  // Add data rows
  bookmarks.forEach(item => {
    rows.push([
      escapeCSVValue(item.bookmark_name || ''),
      escapeCSVValue(item.url || '')
    ]);
  });
  
  return convertRowsToCSV(rows);
};

/**
 * Convert rows array to CSV string
 * @param {Array} rows - Array of row arrays
 * @returns {string} CSV string
 */
const convertRowsToCSV = (rows) => {
  return rows.map(row => {
    return row.map(cell => {
      // If cell contains comma, quote, or newline, wrap in quotes and escape quotes
      if (cell.includes(',') || cell.includes('"') || cell.includes('\n')) {
        return `"${cell.replace(/"/g, '""')}"`;
      }
      return cell;
    }).join(',');
  }).join('\n');
};

/**
 * Escape CSV value - handles quotes and special characters
 * @param {string} value - Value to escape
 * @returns {string} Escaped value
 */
const escapeCSVValue = (value) => {
  if (value === null || value === undefined) {
    return '';
  }
  // Convert to string and handle special characters
  return String(value).replace(/\n/g, ' ').replace(/\r/g, '');
};

